import { createOperationSlice, GenericOperationState } from '@repo/core'
import { MASTER_TABLE_KEYS, type MasterTableItem, type MasterTableKey } from '@repo/shared-types'

const createMasterTableSlice = (key: MasterTableKey) => {
  const initialState: GenericOperationState<MasterTableItem[]> = {
    payload: [],
    meta: { fetchState: 'initial' },
    error: false,
  }
  return createOperationSlice({
    name: `@catalogs/masterTables/${key}`,
    initialState,
    reducers: {},
  })
}

type MasterTableSlice = ReturnType<typeof createMasterTableSlice>

export const masterTableSlices = MASTER_TABLE_KEYS.reduce(
  (acc, key) => ({ ...acc, [key]: createMasterTableSlice(key) }),
  {} as Record<MasterTableKey, MasterTableSlice>,
)

export const masterTableActions = MASTER_TABLE_KEYS.reduce(
  (acc, key) => ({ ...acc, [key]: masterTableSlices[key].actions }),
  {} as Record<MasterTableKey, MasterTableSlice['actions']>,
)

export const masterTableReducers = MASTER_TABLE_KEYS.reduce(
  (acc, key) => ({ ...acc, [key]: masterTableSlices[key].reducer }),
  {} as Record<MasterTableKey, MasterTableSlice['reducer']>,
)
